import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Cookies = () => {
  return (
    <div className="py-16 relative">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Política de Cookies</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">¿Qué son las cookies?</h2>
            <p className="text-gray-700 mb-4 text-justify">
              Una cookie es un pequeño archivo de texto que se almacena en su navegador cuando visita casi cualquier página web. 
              Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página. 
              Las cookies suelen almacenar información de carácter técnico, preferencias personales, personalización de contenidos, 
              estadísticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">Tipos de cookies que utilizamos</h2>
            
            <h3 className="text-xl font-semibold mb-2 text-gray-800">Cookies técnicas</h3>
            <p className="text-gray-700 mb-4 text-justify">
              Son aquellas que permiten al usuario la navegación a través de una página web, plataforma o aplicación 
              y la utilización de las diferentes opciones o servicios que en ella existan.
            </p>

            <h3 className="text-xl font-semibold mb-2 text-gray-800">Cookies analíticas</h3>
            <p className="text-gray-700 mb-4 text-justify">
              Son aquellas que permiten al responsable de las mismas el seguimiento y análisis del comportamiento 
              de los usuarios de los sitios web a los que están vinculadas.
            </p>

            <h3 className="text-xl font-semibold mb-2 text-gray-800">Cookies de personalización</h3>
            <p className="text-gray-700 mb-4 text-justify">
              Son aquellas que permiten al usuario acceder al servicio con algunas características de carácter general 
              predefinidas en función de una serie de criterios en el terminal del usuario.
            </p>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">¿Cómo deshabilitar las cookies?</h2>
            <p className="text-gray-700 mb-4 text-justify">
              Puede usted permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración 
              de las opciones del navegador instalado en su ordenador.
            </p>
            <ul className="list-disc ml-6 text-gray-700">
              <li>Chrome: Configuración {'>'} Mostrar opciones avanzadas {'>'} Privacidad</li>
              <li>Firefox: Opciones {'>'} Privacidad {'>'} Usar una configuración personalizada para el historial</li>
              <li>Internet Explorer: Herramientas {'>'} Opciones de Internet {'>'} Privacidad</li>
              <li>Safari: Preferencias {'>'} Privacidad</li>
            </ul>
          </div>

          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">Cookies de terceros</h2>
            <p className="text-gray-700 mb-4 text-justify">
              Esta web puede utilizar servicios de terceros que, por cuenta de Google, recopilaran información con fines estadísticos, 
              de uso del sitio por parte del usuario y para la prestación de otros servicios relacionados con la actividad del 
              sitio web y otros servicios de Internet.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4 text-blue-600">Actualización de la política</h2>
            <p className="text-gray-700 text-justify">
              VGBComputers puede modificar esta Política de Cookies en función de exigencias legislativas, reglamentarias, 
              o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
              Por esta razón, aconsejamos a los usuarios que la visiten periódicamente.
            </p>
          </div>
        </div>
      </div>
      
      {/* Botón para volver arriba */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Cookies;